module.exports = __webpack_public_path__ + "img/alinoplan_logo.d0bbb565.webp";